import { useEffect } from "react";
import { Link } from "react-router-dom";
import { Reveal, Lines } from "../components/site/Motion";

export default function CookiePage() {
  useEffect(() => {
    document.title = "Cookie Policy — SWAPA";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "Cookie policy di swapa.it: cookie tecnici, preferenze locali, strumenti di terze parti e gestione del consenso.");
  }, []);

  return (
    <div data-testid="cookie-page" className="bg-ink pb-28 pt-32 sm:pt-40">
      <div className="mx-auto max-w-3xl px-5 sm:px-10">
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-swapa-yellow">Legale</p>
        <h1 className="mt-6 font-display font-black uppercase leading-[0.9] tracking-tighter">
          <Lines animate="load" lines={["Cookie policy."]} className="text-4xl text-white sm:text-6xl" />
        </h1>
        <Reveal delay={0.25}>
          <div className="mt-12 space-y-10 text-sm leading-relaxed text-zinc-400">
            <section>
              <h2 className="font-display text-lg font-bold uppercase text-white">Cosa sono i cookie</h2>
              <p className="mt-3">
                I cookie sono piccoli file di testo che i siti salvano sul dispositivo. Questo sito usa anche
                tecnologie analoghe, come il local storage del browser, per ricordare preferenze di navigazione
                come il colore selezionato per SWAPA ZIP.
              </p>
            </section>
            <section>
              <h2 className="font-display text-lg font-bold uppercase text-white">Cookie tecnici</h2>
              <p className="mt-3">
                I cookie tecnici e le preferenze locali servono al funzionamento del sito: navigazione tra le
                pagine, sicurezza delle sessioni amministrative, memorizzazione della configurazione mostrata
                e continuità del flusso di preordine. Questi strumenti non richiedono consenso preventivo.
              </p>
            </section>
            <section>
              <h2 className="font-display text-lg font-bold uppercase text-white">Strumenti di terze parti</h2>
              <p className="mt-3">
                Alcune funzioni coinvolgono fornitori esterni: Stripe per il pagamento sicuro della caparra,
                il feed Instagram tramite Behold e strumenti di misurazione quando attivati. Questi servizi
                possono installare cookie propri secondo le rispettive informative.
              </p>
            </section>
            <section>
              <h2 className="font-display text-lg font-bold uppercase text-white">Gestione del consenso</h2>
              <p className="mt-3">
                Puoi cancellare cookie e dati locali dalle impostazioni del browser in qualsiasi momento. La
                cancellazione può azzerare preferenze come il colore visualizzato o il completamento di un
                flusso già iniziato.
              </p>
            </section>
            <section>
              <h2 className="font-display text-lg font-bold uppercase text-white">Contatti</h2>
              <p className="mt-3">
                Per domande su privacy e cookie scrivi a info@swapa.it. Per l'informativa privacy completa
                visita la pagina{" "}
                <Link to="/privacy" data-testid="cookie-privacy-link" className="text-swapa-yellow underline underline-offset-4">
                  Privacy e note legali
                </Link>
                .
              </p>
            </section>
          </div>
        </Reveal>
      </div>
    </div>
  );
}
